import { ref } from 'vue'

const isOpen = ref(false)

export function useAppNavMenuMobileState() {
  return { isOpen }
}
